<template>
    <transition name="sp-disable-fade">
        <div v-if="open" class="sp-disable-overlay" @click.self="$emit('close')">
            <div class="sp-disable-modal" role="dialog" aria-modal="true">
                <div class="sp-disable-modal__head">
                    <div class="sp-disable-modal__title">Отключить сценарий?</div>
                    <div class="sp-disable-modal__text">{{ message }}</div>
                </div>
                <div class="sp-disable-modal__foot">
                    <button type="button" class="btn-ghost" :disabled="disabling" @click="$emit('close')">
                        Отмена
                    </button>
                    <button type="button" class="btn-danger" :disabled="disabling" @click="$emit('confirm')">
                        {{ disabling ? 'Отключение...' : 'Отключить' }}
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'StarterPackDisableConfirmModal',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '',
        },
        disabling: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        open(isOpen) {
            if (isOpen) {
                document.addEventListener('keydown', this.onEscape)
                return
            }
            document.removeEventListener('keydown', this.onEscape)
        },
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.onEscape)
    },
    methods: {
        onEscape(event) {
            if (event.key === 'Escape' && !this.disabling) {
                this.$emit('close')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.sp-disable-overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(26, 26, 46, 0.44);
}

.sp-disable-modal {
    width: 100%;
    max-width: 470px;
    overflow: hidden;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 16px;
    box-shadow: 0 8px 40px rgba(26, 26, 46, 0.18);
}

.sp-disable-modal__head {
    padding: 24px 24px 16px;
}

.sp-disable-modal__title {
    margin-bottom: 12px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 20px;
    font-weight: 900;
    letter-spacing: -0.02em;
}

.sp-disable-modal__text {
    color: $muted-new;
    font-size: 13px;
    line-height: 1.55;
    white-space: pre-line;
}

.sp-disable-modal__foot {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 18px 24px 22px;
}

.btn-ghost,
.btn-danger {
    padding: 11px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13px;
    font-weight: 700;

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
}

.btn-ghost {
    color: $text-color-new;
    background: #fff;
    border: 1.4px solid $border-new;

    &:hover:not(:disabled) {
        background: $bcg-card-new;
    }
}

.btn-danger {
    color: #fff;
    background: #c0392b;
    border: 0;
    box-shadow: 0 2px 10px rgba(192, 57, 43, 0.24);

    &:hover:not(:disabled) {
        background: #a93226;
    }
}

.sp-disable-fade-enter-active,
.sp-disable-fade-leave-active {
    transition: opacity 0.2s ease;
}

.sp-disable-fade-enter,
.sp-disable-fade-leave-to {
    opacity: 0;
}
</style>
